import { addHook } from 'dompurify';

const TARGET_ATTR = 'data-target';
const FOLLOW_ATTR = 'data-follow';

// Allows the use of target on links in sanitized HTML in a safe manner.

export default () => {
  addHook('beforeSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('target')) {
      node.setAttribute(TARGET_ATTR, node.getAttribute('target'));
    }
  });

  addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute(TARGET_ATTR)) {
      node.setAttribute('target', node.getAttribute(TARGET_ATTR));
      node.removeAttribute(TARGET_ATTR);

      if (node.getAttribute('target') === '_blank') {
        const rel = new Set([
          ...(node.getAttribute('rel') || '').split(' '),
          'noopener',
          'noreferrer',
          node.hasAttribute(FOLLOW_ATTR) ? '' : 'nofollow',
        ]).filter(Boolean).join(' ');

        node.removeAttribute(FOLLOW_ATTR);
        node.setAttribute('rel', rel);
      }
    }
  });
};
